<app-breadcrumbs></app-breadcrumbs>
<div [cfaLoading]="wan1InterfaceLoading || gatewayInfoLoading">
  <button mat-raised-button color="primary" id="store-number-search-button" (click)="getConfigItems()">
    <mat-icon>search</mat-icon>
  </button>
  <mat-form-field id="store-number-search-field" appearance="outline">
    <mat-label>Store Number</mat-label>
    <input matInput maxlength="5" minLength="5" [(ngModel)]="storeNumber" autofocus
      (keydown.enter)="getConfigItems()"/>
  </mat-form-field>
</div>
<div class="card-wrapper">
  @if (wan1Interface != null) {
    <mat-card>
      <mat-card-header>
        <mat-card-title>WAN 1 Interface</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-divider></mat-divider>
        <!-- <p><b>Description:</b> {{wan1Interface.description}}</p>
        <p><b>Status:</b> {{wan1Interface.status}}</p> -->
        <p><b>Bandwidth In:</b> {{wan1Interface.provisioned_bandwidth_in}}</p>
        <p><b>Bandwidth Out:</b> {{wan1Interface.provisioned_bandwidth_out}}</p>
        <!-- <p><b>Default Gateway:</b> {{wan1Interface.default_gw}}</p> -->
        <p><b>IP:</b> {{wan1Interface.ip}}</p>
        <!-- <p><b>Mode:</b> {{wan1Interface.mode}}</p> -->
        <!-- <p><b>Distance:</b> {{wan1Interface.distance}}</p> -->
        <p><b>Speed:</b> {{wan1Interface.speed}}</p>
      </mat-card-content>
    </mat-card>
  }
  @if (gatewayInfo != null) {
    <mat-card>
      <mat-card-header>
        <mat-card-title>Gateway Info</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-divider></mat-divider>
        <p><b>Gateway IP:</b> {{gatewayInfo.gateway}}</p>
      </mat-card-content>
    </mat-card>
  }
</div>